"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../typography");
var DynamicIcon_1 = require("../DynamicIcon");
var TagSizeStyles = (_a = {},
    _a['small'] = [design_system_theme_1.FontSizes.fontSize12],
    _a['medium'] = [design_system_theme_1.FontSizes.fontSize14],
    _a['large'] = [design_system_theme_1.FontSizes.fontSize16],
    _a);
var TagContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"])));
var TagLabel = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, contrast = _a.contrast, theme = _a.theme;
    return ({
        sizes: TagSizeStyles[$size],
        color: contrast === 'low'
            ? theme.colors.text.secondary
            : theme.colors.text.primary,
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  line-height: 1;\n"], ["\n  display: inline-block;\n  line-height: 1;\n"])));
var StyledIcon = (0, styled_components_1.default)(DynamicIcon_1.DynamicIcon).attrs(function (_a) {
    var contrast = _a.contrast, theme = _a.theme;
    return ({
        primaryColor: contrast === 'low'
            ? theme.colors.text.secondary
            : theme.colors.text.primary,
        width: 12,
        height: 12,
    });
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var position = _a.position;
    return position === 'right'
        ? (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          margin-left: 8px;\n        "], ["\n          margin-left: 8px;\n        "]))) : (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          margin-right: 8px;\n        "], ["\n          margin-right: 8px;\n        "])));
});
/**
 * A simple text component used for providing meta data.
 */
var Tag = function (_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.contrast, contrast = _c === void 0 ? 'high' : _c, LeftIcon = _a.LeftIcon, RightIcon = _a.RightIcon;
    return (react_1.default.createElement(TagContainer, null,
        LeftIcon ? (react_1.default.createElement(StyledIcon, { Icon: LeftIcon, contrast: contrast, position: "left", "aria-hidden": "true" })) : null,
        react_1.default.createElement(TagLabel, { "$size": size, contrast: contrast }, label),
        RightIcon ? (react_1.default.createElement(StyledIcon, { Icon: RightIcon, contrast: contrast, position: "right", "aria-hidden": "true" })) : null));
};
exports.Tag = Tag;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
